import moment from 'moment'
import { BUSINESS_STATUSES } from '@/lib/consts.js'

import AmericanExpressImage from '@/assets/credit-card/brands/American Express.svg'
import DinnersClub2Image from '@/assets/credit-card/brands/Diners Club 2.svg'
import DinnersClubImage from '@/assets/credit-card/brands/Diners Club.svg'
import JCBImage from '@/assets/credit-card/brands/JCB.svg'
import MaestroImage from '@/assets/credit-card/brands/maestro.svg'
import MasterCardImage from '@/assets/credit-card/brands/MasterCard.svg'
import UnionPayImage from '@/assets/credit-card/brands/UnionPay.svg'
import UnknownImage from '@/assets/credit-card/brands/Unknown.svg'
import VisaImage from '@/assets/credit-card/brands/Visa.svg'

export const PAYOUT_METHOD = {
  FAST: 'fast',
  STANDARD: 'standard',
}

export const PAYOUT_STATUS = {
  CANCELED: 'canceled',
  FAILED: 'failed',
  IN_TRANSIT: 'in_transit',
  PAID: 'paid',
  PENDING: 'pending',
}

export const PAYOUT_METHOD_TYPE = {
  CARD: 'card',
  BANK_ACCOUNT: 'bank_account',
}

export const FAST_PAYOUTS_STATUS = {
  HIDDEN: 'hidden',
  BLOCKED: 'blocked',
  MISSING_KYC: 'missing_kyc',
  COMPLETE_FIRST_TRANSACTION: 'complete_first_transaction',
  MERCHANT_DISABLED: 'merchant_disabled',
  WRONG_BANK_ACCOUNT: 'wrong_bank_account',
  WRONG_DEBIT_CARD: 'wrong_debit_card',
  AVAILABLE_TOMORROW: 'available_tomorrow',
  AVAILABLE: 'available',
  MISSING_PAYOUT_METHOD: 'missing_payout_method',
}

export const FAST_PAYOUT_DESCRIPTION_LENGTH_MAX = 30

export const DEFAULT_FAST_PAYOUT_DESCRIPTION = `FP/${moment().format('MMDDYYYY')}`

export const CREDIT_CARD_BRANDS = {
  'American Express': AmericanExpressImage,
  'Diners Club 2': DinnersClub2Image,
  'Diners Club': DinnersClubImage,
  JCB: JCBImage,
  Maestro: MaestroImage,
  MasterCard: MasterCardImage,
  UnionPay: UnionPayImage,
  Visa: VisaImage,
  Unknown: UnknownImage,
}

export const DEFAULT_CREDIT_CARD_BRAND = 'Unknown'

export const COLORS = {
  SUCCESS: '#00c479',
  DANGER: '#d82e48',
}

export const TRANSACTION_TYPES = {
  CHARGE: 'charge',
  REFUND: 'refund',
  PAYMENT: 'payment',
  PAYMENT_REFUND: 'payment_refund',
  TRANSFER: 'transfer',
}

export const FAST_PAYOUT_MAX_LIMIT = 5000
export const FAST_PAYOUT_MIN_LIMIT = 100

export const RESTRICTED_FAST_PAYOUTS_STATUSES_IN_SETTINGS = [
  FAST_PAYOUTS_STATUS.COMPLETE_FIRST_TRANSACTION,
  FAST_PAYOUTS_STATUS.HIDDEN,
  FAST_PAYOUTS_STATUS.MISSING_KYC,
]

export const RESTRICTED_BUSINESS_STATUSES_IN_SETTINGS = [
  BUSINESS_STATUSES.TRIAL,
  BUSINESS_STATUSES.TRIAL_BLOCKED,
]

export const FAST_PAYOUTS_SCREEN_NAMES = {
  SALES_SCREEN: 'fast_payouts_sales_screen',
  MAKE_PAYOUT: 'fast_payouts_make_payout',
  HISTORY: 'fast_payouts_history',
  PAYOUT_SUMMARY: 'fast_payouts_payout_summary',
  CONFIRMATION_POPUP: 'fast_payouts_confirmation_popup',
  ACCOUNT_DETAILS: 'fast_payouts_account_details',
  PAYOUT_DETAILS: 'fast_payouts_payout_details',
}
